import brand from '@helpers/brand';
import { cssVar, setCssVar } from '@helpers/cssVar';
import { Device, from, until } from '@helpers/media';
import { SitePadding } from '@stories/Components/Global/SiteWide/SiteWide.styles';
import HeadingStyles from '@stories/Components/Global/Typography/Heading.styles';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import styled, { css } from 'styled-components';
const Container = styled(SectionWrapper) `
  ${setCssVar('accentColor', brand.hta.green)};
  ${setCssVar('bgColor', brand.grey)};
  ${setCssVar('bgColorAlt', brand.greyVeryLight)};
  ${setCssVar('fgColor', brand.white)};
  color: ${cssVar('fgColor')};

  .theme-hh & {
    ${setCssVar('bgColor', brand.white)};
    ${setCssVar('fgColor', brand.black)};
    ${setCssVar('fgColorAlt', brand.hortHouse.green)};
  }
`;
const Inner = styled.div `
  display: grid;
  grid-template-columns: 1fr;

  ${({ background, videoOnly }) => background && !videoOnly &&
    css `
      ${background === 'gray1' && `background-color: ${cssVar('bgColor')}`};
      ${background === 'gray2' && `background-color: ${cssVar('bgColorAlt')}`};
      ${background === 'green' && `background-color: ${cssVar('accentColor')}`};
      border-radius: 11px;
      padding: 32px ${SitePadding}px;
    `}
    
  @media ${from(Device.Tablet)} {
    gap: 30px;
    grid-template-columns: 7fr 5fr;

    ${({ videoOnly }) => videoOnly && css `
      display: flex;
      align-items: center;
      flex-direction: column;
      margin: 0 auto;
      text-align: center;
    `}
  }
`;
const VideoWrapper = styled.div `
  ${({ videoOnly }) => videoOnly && css `
        width: 50%;
  `}

  @media ${until(Device.Tablet)} {
    ${({ videoOnly }) => videoOnly && css `
        width: 100%;
    `}

    position: relative;
    padding-bottom: ${(9 / 16) * 100}%;

    > div {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
    }
  }

  @media ${from(Device.Tablet)} {
    display: grid;
    min-height: 471px;
  }
`;
const ContentWrapper = styled.div `
  background-color: ${cssVar('bgColor')};

  @media ${until(Device.Tablet)} {
    border-radius: 0 0 11px 11px;
    padding: 16px 10px;
  }

  @media ${from(Device.Tablet)} {
    border-radius: 0 50px 50px 0;
    padding: 64px 30px;
    margin: 56px 0;
    margin-left: -30px;
  }
`;
const Title = styled.h2 `
  ${HeadingStyles.H4Styles};
  color: ${cssVar('accentColor')};
`;
const Content = styled.div `
  font-size: 18px;
  line-height: 28px;

@media ${from(Device.Tablet)} {
  font-size: 22px;
  line-height: 32px;
}
  margin: 0 0 16px;
`;
const CtaWrapper = styled.div ``;
export default {
    Container,
    Content,
    ContentWrapper,
    CtaWrapper,
    Inner,
    Title,
    VideoWrapper,
};
